import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json'

export default {
  getRecipes({
    language, skip, take, activeCategories = [], terms = [], sorting = null
  }) {
    const params = {
      skip,
      take,
      sorting,
      terms: encodeURIComponent(terms.join('|')),
      categories: encodeURIComponent(activeCategories.join('|'))
    }
    return axios.get(`/${language}/api/search/recipes`, { params })
  },
  getProducts({
    language, skip, take, activeCategories = [], terms = [], sorting = null
  }) {
    const params = {
      skip,
      take,
      sorting,
      terms: encodeURIComponent(terms.join('|')),
      categories: encodeURIComponent(activeCategories.join('|'))
    }
    return axios.get(`/${language}/api/search/products`, { params })
  },
  getSearchItems({
    take,
    skip,
    searchType,
    searchTypes = [],
    activeCategories = [],
    terms = [],
    sorting = null,
    language = null
  }) {
    const params = {
      skip,
      take,
      sorting,
      searchType,
      searchtypes: searchTypes.join('|'),
      terms: encodeURIComponent(terms.join('|')),
      categories: encodeURIComponent(activeCategories.join('|')),
      language
    }
    return axios.get(`/${language}/api/search/searchitems`, { params })
  },
  getAutoSuggestions(query, language, searchType) {
    const params = {
      query: encodeURIComponent(query),
      language,
      searchType
    }
    return axios.get(`/${language}/api/search/autosuggestion`, { params })
  },
  trackItemClick(params) {
    axios.get('/api/search/trackitemclick', { params })
  },
  trackAutoSuggestionClick(params) {
    axios.get('/api/search/trackautosuggestionclick', { params })
  }
}
